module.exports = __webpack_public_path__ + "static/media/m_sf_6.5bfc924c.png";